// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__10rZ5","title":"AfterImages45_title__1HbMp","images":"AfterImages45_images__1SR9Y"};